import React from 'react';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader } from '@mui/material';
import { useSelector } from 'react-redux';

import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

import ConfirmExit from './ConfirmExit';

export const ListSubheaderStyle = styled(props => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  })
);

// ----------------------------------------------------------------------

export const NavSectionVertical = ({ navConfig, isCollapse = false, ...other }) => {
  const { employeePermissions } = useSelector(state => state.app);
  const { pathname } = useLocation();
  const [open, setOpen] = React.useState(false);
  const [url, setUrl] = React.useState('');

  const handleOpen = path => {
    setUrl(path);
    setOpen(true);
  };

  return (
    <>
      <Box {...other}>
        {navConfig.map(group => (
          <List key={group.subheader} disablePadding sx={{ px: 2 }}>
            <ListSubheaderStyle
              sx={{
                ...(isCollapse && {
                  opacity: 0
                })
              }}
            >
              {group.subheader}
            </ListSubheaderStyle>

            {group.items.map(list => {
              if (_.isNil(list.permission) || employeePermissions.includes(list.permission)) {
                if (pathname === '/employee/form-list' && list.path !== 'form-list') {
                  return <NavListRoot key={list.title} list={list} confirm={true} confirmHandleOpen={handleOpen}/>;
                }

                return <NavListRoot key={list.title} list={list} />;

              }
            }
            )}
          </List>
        ))}
      </Box>
      <ConfirmExit open={open} handleClose={() => setOpen(false)} url={url}/>
    </>
  );
};
